import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getNotificationPreferences,
  updateNotificationPreferences,
} from "app/services/notificationPreference/notificationPreference";
import { BASE_URL } from "static/constants";

export const notificationPreferenceApi = createApi({
  reducerPath: "notificationPreferenceApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["NotificationPreferences"],
  endpoints: ({ query, mutation }) => ({
    getNotificationPreferences: query({
      queryFn: ({ account }) => {
        return { data: getNotificationPreferences({ account }) };
      },
      providesTags: (_, __, { account }) => [
        { type: "NotificationPreferences", id: account },
      ],
    }),
    updateNotificationPreferences: mutation({
      queryFn: async (payload) => {
        try {
          return { data: await updateNotificationPreferences(payload) };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: (_, __, { account }) => [
        { type: "NotificationPreferences", id: account },
      ],
    }),
  }),
});

export const {
  useGetNotificationPreferencesQuery,
  useUpdateNotificationPreferencesMutation,
} = notificationPreferenceApi;
